import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Flex, Text } from "@chakra-ui/react";
import { useMeeting, useSidebar } from "@hooks";
import useChat from "@hooks/useChat";
import {
  panelActivated,
  panelDeactivated,
  selectChatConnectionStatus,
} from "@store/chatSlice";
import ChatMessageList from "./ChatMessageList";
import ChatComposer from "./ChatComposer";

const CHAT_TAB_INDEX = 2;

const ChatPanel = () => {
  const dispatch = useDispatch();
  const { isSidebarOpen, tabIndex } = useSidebar();
  const { isMeetingActive } = useMeeting();
  const connectionStatus = useSelector(selectChatConnectionStatus);
  const { sendMessage, retryMessage, discardMessage } = useChat();

  const isActive = isSidebarOpen && tabIndex === CHAT_TAB_INDEX;
  const isDisconnected = connectionStatus === "disconnected";
  const isOutsideLiveMeeting = !isMeetingActive;

  useEffect(() => {
    if (isActive) {
      dispatch(panelActivated());
    } else {
      dispatch(panelDeactivated());
    }
  }, [isActive, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(panelDeactivated());
    };
  }, [dispatch]);

  return (
    <Flex direction="column" flex="1" minH="0" height="100%" pt="10px">
      <ChatMessageList
        isActive={isActive}
        onRetry={retryMessage}
        onDiscard={discardMessage}
      />
      {isOutsideLiveMeeting && (
        <Text fontSize="10px" color="dark.300" textAlign="center" pt="6px">
          Chat is available during live meetings
        </Text>
      )}
      {!isOutsideLiveMeeting && isDisconnected && (
        <Text fontSize="10px" color="dark.300" textAlign="center" pt="6px">
          Reconnecting…
        </Text>
      )}
      <ChatComposer
        onSend={sendMessage}
        isDisabled={isDisconnected || isOutsideLiveMeeting}
      />
    </Flex>
  );
};

export default ChatPanel;
